<template>
  <div>
    <HeaderSteps title="Add assets" :back-path="-1"> </HeaderSteps>
    <Assets />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignPeriod from '@/components/social-products/social-boost/forms/PeriodBudget.vue'
import Assets from '@/components/social-products/social-boost/forms/Assets.vue'
import SocialBoostCampaignMixin from '@/mixins/social-products/social-boost-campaign'

export default {
  name: 'CreateAssets',
  mixins: [SocialBoostCampaignMixin],
  components: {
    HeaderSteps,
    CampaignPeriod,
    Assets,
  },
  data() {
    return {}
  },
  created() {
    this.updateStoreFormDetails()
  },
  computed: {
    ...mapGetters('socialBoostCampaign', ['campaign']),
    ...mapGetters('app', ['is_loading']),
  },
  methods: {
    getCurrentStep(step) {
      this.currentStep = step === 2 ? 1 : step
    },
  },
}
</script>
